import { ActionIcon, Button } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import CogIcon from 'shared/ui/assets/icons/cog-icon.svg?react';
import { fairnessModalModel } from '../../model';

export const FairnessModalButton = () => {
	const { t } = useTranslation();

	const { enable } = useUnit(fairnessModalModel.switcher);

	return (
		<Button
			variant='standard'
			leftSection={
				<ActionIcon
					variant='secondary'
					component='div'
				>
					<CogIcon />
				</ActionIcon>
			}
			onClick={enable}
		>
			{t('fairness-modal.button-label')}
		</Button>
	);
};
